    <div class="loader" *ngIf="loading">
      <mat-spinner [diameter]="150"></mat-spinner>
    </div>
    <div class="card">
      <app-header></app-header>
      <div class="container">
        <div class="background" >
          <div class="fundo"></div>
        </div>
          <form [formGroup]="forgotPasswordFormGroup" class="forgot-password-form" autocomplete="off" >
            <div data-test="titulo-esqueci-senha" class="title">
              <p>{{'forgot.title' | translate}}</p>
            </div> 
            <div data-test="texto-explicativo-recuperação" class="subTitle">
              <p>{{'forgot.caption' | translate}}</p>
            </div>
              <fieldset [disabled]="loading" class="fieldset">
                <mat-form-field class="full-input-grid" appearance="outline">
                  <mat-label>{{ 'signUp.email' | translate }}</mat-label>
                  <input data-test="campo-email-esqueci-senha" type="email" matInput formControlName="email" placeholder="Ex: example@example.com">
                  <mat-error *ngIf="form['email'].invalid && !form['email'].hasError('emailExists')">{{message.errorMessage(form['email'])}}</mat-error>
                  <mat-error *ngIf="form['email'].invalid && form['email'].hasError('emailExists')">{{ message.emailInUse(form['email'].value)}}</mat-error>
                </mat-form-field>
                <div>
                  <a class="redirect-link" routerLink="/sign-in">{{ 'forgotPassword.message' | translate }}</a>
                  <button data-test="btn-esqueci-senha" class="full-input-grid button" mat-raised-button color="primary" (click)="resetPassword()">{{ 'forgotPassword.button' | translate }}</button>
                </div>
              </fieldset>
          </form>
      </div>
    </div>
        


